// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3rRgG","info":"PatientInfo_info__1odi3"};